import {
    Box,
    Button,
    CssBaseline,
    Paper,
    Stack,
    Typography,
    useTheme
} from '@mui/material';
import { Table, Container, Row, Col } from 'react-bootstrap';

import React, { useContext, useRef, useState } from 'react';
import Pagination from '../../general/Pagination';
import ExportContent from '../../ExportContent';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';


import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import AppModal from '../../AppModal';
import {PASS_KEY,WEB_KEY,BaseUrl} from '../../../api/AxiosApi'
import ExportContentEnergy from '../../ExportContentEnergy';
import { AuthenticationContext } from '../../../context/AuthenticationContext';
import ExportExcel from '../../exportExcel/ExportExcel1';
import ExportPdf from '../../exportPdf/ExportPdf';
let Radiation;
export default function EnergyReportingLogTable({ radiationName, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const tableRef = useRef(null);

    const LOGIN_ID = localStorage.getItem('LoginID')

    const LOC_CODE = LoggedInUserInfo?.Loc_Code
    

    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(15);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }

    const logo = require('../../../assets/img/logos/logo 2.png');

    // function genPDF() {
    //     const textX = 20; // Left side text position X
    //     const textY = 20; // Top margin
    //     const logoWidth = 50;
    //     const logoHeight = 30;
    //     const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

    //     // Import images
    //     const imgData = require('../../../assets/img/logos/logo 2.png');
    //     // const rightImg = require('../../../assets/img/logos/rightImg.png'); 

    //     // Get PDF page width
    //     const pdfWidth = pdf.internal.pageSize.getWidth();

    //     // --- LEFT SIDE TEXT (Company Name & Address) ---
    //     pdf.setFontSize(15);
    //     pdf.setFont("helvetica", "bold");
    //     pdf.text(`Plant Name/User Name:${LoggedInUserInfo?.username}`, textX, textY + 10);
    //     pdf.setFontSize(10);
    //     pdf.setFont("helvetica", "bold");
    //     pdf.text(`Plant Capacity :${LoggedInUserInfo?.PLANT_CAPACITY}`, textX, textY + 16);
    //     pdf.text(`Plant Address :${LoggedInUserInfo?.Address}`, textX, textY + 22);


    //     // --- CENTER LOGO ---
    //     const logoX = (pdfWidth - logoWidth) / 2;
    //     pdf.addImage(imgData, 'JPEG', logoX, textY, logoWidth, logoHeight);

    //     // --- RIGHT SIDE IMAGE ---
    //     const rightImgWidth = 100;
    //     const rightImgHeight = 35;
    //     const rightX = pdfWidth - rightImgWidth - 20; // 20px margin from right
    //     pdf.addImage(ImageUrl, 'JPEG', rightX, textY, rightImgWidth, rightImgHeight);

    //     // --- TITLE BELOW HEADER ---
    //     const title = `${radiationName} ${ValueOf2}`;
    //     pdf.setFontSize(12);
    //     const titleWidth =
    //         pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
    //     const titleX = (pdfWidth - titleWidth) / 2;
    //     pdf.text(title, titleX, textY + logoHeight + 15);

    //     // --- TABLE DATA ---
    //     pdf.autoTable({
    //         html: '#table-to-pdf',
    //         startY: textY + logoHeight + 25,
    //     });

    //     // Save PDF
    //     pdf.save(`Daily Energy Log  From ${ValueOf1} To ${ValueOf2}.pdf`);
    // }


    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(TableData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Energy Report");
    //     // XLSX.writeFile(wb, `Daily Energy Log To ${ValueOf2} ${radiationName}.xlsx`);
    //     XLSX.writeFile(wb, `Daily Energy  ${LoggedInUserInfo?.username} From ${ValueOf1} To ${ValueOf2} .xlsx`);
    // };

//   const exportToExcel = async () => {
//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet("Daily Energy Report");  

//         try {
//             // ===== Load uploaded image (static file instead of API) =====
//             const response = await fetch(ImageUrl);
//             const blob = await response.blob();
//             const base64Logo = await new Promise((resolve, reject) => {
//                 const reader = new FileReader();
//                 reader.readAsDataURL(blob);
//                 reader.onloadend = () => resolve(reader.result);
//                 reader.onerror = reject;
//             });

//             // ===== Add image to Excel =====
//             const logo = workbook.addImage({
//                 base64: base64Logo,
//                 extension: "png",
//             });

//             // Place logo on top-left
//             worksheet.mergeCells("A1:D4"); // Logo space
//             worksheet.addImage(logo, {
//                 tl: { col: 0, row: 0 }, // top-left corner
//                 ext: { width: 250, height: 65 }, // adjust size
//             });

//             // ===== Company Name & Address (Dynamic) =====
//             const companyName = LoggedInUserInfo?.username || "";
//             const companyAddress = LoggedInUserInfo?.Address || "";

//             // Company Name row
//             worksheet.mergeCells("F1:P2");
//             worksheet.getCell("F1").value = `Plant Name/User Name: ${companyName}`;
//             worksheet.getCell("F1").font = { size: 14, bold: true };
//             worksheet.getCell("F1").alignment = { vertical: "middle", horizontal: "left" };

//             // Address row
//             worksheet.mergeCells("F3:P4");
//             worksheet.getCell("F3").value = `Plant Address: ${companyAddress}`;
//             worksheet.getCell("F3").font = { size: 11, color: { argb: "555555" } };
//             worksheet.getCell("F3").alignment = { vertical: "middle", horizontal: "left" };


//         } catch (error) {
//             console.error("Logo fetch/convert error:", error);
//         }

//         // ===== Table Header =====
//         worksheet.addRow([]);
//         worksheet.addRow(Object.keys(TableData[0] || {}));
//         TableData.forEach((item) => {
//             worksheet.addRow(Object.values(item));
//         });

//         // ===== Export file =====
//         const buffer = await workbook.xlsx.writeBuffer();
//         saveAs(
//             new Blob([buffer]),
//             `Daily Energy  ${LoggedInUserInfo?.username} From ${ValueOf1} To ${ValueOf2} .xlsx`
//         );
//     };


const genPDF = async () => {
    await ExportPdf(
        ImageUrl,
        TableData,
        ValueOf1,
        ValueOf2,
        "Daily Energy Log",
        LoggedInUserInfo,
        logo,
        TableHead

    );
};


const exportToExcel = async () => {
    await ExportExcel(
        ImageUrl,
        TableData,
        ValueOf1,
        ValueOf2,
        "Daily Energy Log",
        LoggedInUserInfo
    );
};

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // console.log("tableRef.current", tableRef)

    return (
        <>
            <CssBaseline />
            <Box component={Stack} rowGap={spacing(1)} sx={{ bgcolor: 'background.default', py: spacing(1) }}>
                <ExportContentEnergy
                    excelTableRef={exportToExcel}
                    onGenPdf={genPDF}
                    ExcelExportFileName={`Daily Energy Log To ${ValueOf2} ${radiationName}`}
                    title={radiationName}
                    onFullScreen={handleOpen}
                    filterContent={
                        <Box flex={1} columnGap={spacing(1)} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOF1} name='startDate' />
                            <Typography variant='body1' >To</Typography>
                            <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOF2} name='endDate' />
                            <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                        </Box>

                    }
                />

                {
                    currentRecords?.length > 0 ? <>


                        {/* TableContainer for making the table responsive */}

                        <div>
                            <Table ref={tableRef} id='table-to-pdf' striped bordered hover responsive>
                                <thead style={{}}>
                                    <tr style={{ textAlign: 'center' }}>
                                        {
                                            TableHead?.map((item, index) => {
                                                return (
                                                    <th style={{ padding: 15, whiteSpace: 'nowrap', backgroundColor: "#FDF8E4", color: palette.primary.main }} key={index}>{item}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords?.map((item, index) => {
                                            // console.log('data', item)
                                            return (
                                                <tr key={index}>
                                                    {TableHead.map(key =>
                                                        <td style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
                                                    )}
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>


                        </div>

                        {/* Pagination */}
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Pagination nPages={nPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                        </Box>

                        {/* AppModal */}
                        <AppModal open={open} handleClose={handleClose}></AppModal>



                    </>

                        : <>
                            <Typography variant='body2' color={'black'} textAlign={'center'}>Data Loading...</Typography>
                        </>
                }

            </Box>
        </>
    )
}
